<!-- Define our application header. -->
<mat-toolbar class="hrl-header" color="primary">

  <!-- Display the menu icon. -->
  <!-- <button *ngIf="!menuHidden" mat-icon-button (click)="menuToggle()">
    <mat-icon>menu</mat-icon>
  </button> -->

  <!-- Display the title of our application -->
  <h1 *ngIf="!menuHidden" class="hrl-layout-header-application-name">
    PrismHR Integration Administration
  </h1>

  <!-- Move to the right side of the toolbar -->
  <span class="hrl-toolbar-spacer"></span>

  <!-- Administrator Information -->
  <app-layout-partial-admin-information></app-layout-partial-admin-information>

  <!-- Employee Information -->
  <app-layout-partial-employee-information></app-layout-partial-employee-information>
</mat-toolbar>

<!-- Display the loading-indicator indicator. -->
<app-loading-indicator></app-loading-indicator>

<!-- Define our application container. -->
<mat-sidenav-container class="hrl-sidenav-container mat-elevation-z0">

  <!-- Define our navigation menu. -->
  <mat-sidenav *ngIf="!menuHidden" opened="true"
               class="hrl-sidenav mat-elevation-z0"
               (mouseenter)="expand()"
               (mouseleave)="shrink()"
               [fixedBottomGap]="56"
               [fixedInViewport]="true"
               [fixedTopGap]="56"
               [ngStyle]="{ 'width.em': menuWidth }"
               mode="side">
    <mat-nav-list>

      <!-- Dashboard -->
      <mat-list-item [routerLink]="['/admin/dashboard']" [routerLinkActive]="['hrl-sidenav-active-list-item']"
                     [routerLinkActiveOptions]="{ exact: true }">
        <mat-icon matListItemIcon color="icon-orange">speed</mat-icon>
        <div *ngIf="open()" matListItemTitle>Dashboard</div>
        <div *ngIf="open()" matListItemLine>PrismHR Integration Dashboard.</div>
      </mat-list-item>

      <!-- Manage the PEOs -->
      <mat-list-item [routerLink]="['/admin/peo']" [routerLinkActive]="['hrl-sidenav-active-list-item']"
                     [routerLinkActiveOptions]="{ exact: true }">
        <mat-icon matListItemIcon color="icon-orange">domain_add</mat-icon>
        <div *ngIf="open()" matListItemTitle>Professional Employer Organizations</div>
        <div *ngIf="open()" matListItemLine>Manage the PEOs in the solution.</div>
      </mat-list-item>

      <!-- Test the PrismHR API Credentials -->
      <mat-list-item [routerLink]="['/admin/peo/api-credential-test']"
                     [routerLinkActive]="['hrl-sidenav-active-list-item']" [routerLinkActiveOptions]="{ exact: true }">
        <mat-icon matListItemIcon color="icon-orange">vpn_key</mat-icon>
        <div *ngIf="open()" matListItemTitle>PrismHR API Credential Test</div>
        <div *ngIf="open()" matListItemLine>Test all stored PrismHR API Credentials.</div>
      </mat-list-item>

      <!-- CSV Client-Customer Import Wizard -->
      <mat-list-item [routerLink]="['/admin/import/wizard']" [routerLinkActive]="['hrl-sidenav-active-list-item']"
                     [routerLinkActiveOptions]="{ exact: true }">
        <mat-icon matListItemIcon color="icon-orange">difference</mat-icon>
        <div *ngIf="open()" matListItemTitle>PEO Client-Customer Import</div>
        <div *ngIf="open()" matListItemLine>Import Client-Customer Mappings from CSV.</div>
      </mat-list-item>

      <!-- .NET API Documentation -->
      <mat-list-item (click)="openIntegrationDocumentation()">
        <mat-icon matListItemIcon color="icon-orange">integration_instructions</mat-icon>
        <div *ngIf="open()" matListItemTitle>Integration API Documentation</div>
        <div *ngIf="open()" matListItemLine>Documentation for the .NET API that powers this UI.</div>
      </mat-list-item>

      <!-- Manage the Administrators -->
      <mat-list-item [routerLink]="['/admin/manage']" [routerLinkActive]="['hrl-sidenav-active-list-item']"
                     [routerLinkActiveOptions]="{ exact: true }">
        <mat-icon matListItemIcon color="icon-orange">admin_panel_settings</mat-icon>
        <div *ngIf="open()" matListItemTitle>Administrators</div>
        <div *ngIf="open()" matListItemLine>Manage the Administrators with access to the UI.</div>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>

  <!-- Define our application content. -->
  <mat-sidenav-content [ngClass]="{'hrl-sidenav-content': !menuHidden}" class="mat-elevation-z0">

    <!-- Define our application viewport. -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Define our application footer. -->
<mat-toolbar class="hrl-footer">
  <span class="mat-body">&copy; {{ year }} Selerix Systems, Inc.&nbsp;&nbsp;All rights reserved.</span>
  <span class="hrl-toolbar-spacer">&nbsp;</span>
  <span class="mat-body">
    &nbsp;
  <!--<img alt="SyncStream Solutions, LLC"
       height="22"
       ngSrc="assets/hrlogics-aca.svg"
       width="130.33"> -->
  </span>
</mat-toolbar>
